import React from 'react'
import video from '../assets/video/verse_homepage_loop.mp4';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { contentData } from '../data/contentData';
import StatsCounter from './StatsCounter';

function HeroSection() {
    const { language } = useLanguage();
    const content = contentData[language].hero;

    return (
        <div>
            <main className="page_main">
                <header className="hero_wrap">
                    <div className="g_visual_wrap u-position-relative u-cover-absolute" STYLE="object-position: 50% 50%;">
                        <div className="g_visual_background u-cover-absolute">
                        </div>

                        <video src={video} autoPlay={false} loop={true} muted={true} preload="none" playsInline={true} data-video="playpause" className="g_visual_video g_visual_video_hero u-cover-absolute"></video>

                    </div>
                    <div data-wf--global-section-space--section-space="main" className="g_section_space w-variant-60a7ad7d-02b0-6682-95a5-2218e6fd1490">
                    </div>
                    <div className="hero_contain u-container">
                        <div className="hero_layout" style={{ maxWidth: '120ch' }}>
                            <h1 className="hero_title u-text-style-h1" style={{ 
                                fontFamily: '"Roboto", "Poppins", sans-serif',
                                paddingTop: '20px',
                                fontSize: 'clamp(2rem, 5vw, 3.5rem)',
                                marginBottom: '40px'
                            }} data-aos="fade-down" data-aos-duration="1000">
                                {content.title}
                            </h1>
                            <p className="hero_title u-text-style-h4" style={{ fontFamily: '"Tinos", "Times New Roman", serif' }} dangerouslySetInnerHTML={{ __html: content.description }} data-aos="fade-up" data-aos-delay="200"></p>

                            {/* Modern Badges Section with Glass Morphism */}
                            <div className="mb-4" style={{ 
                                marginTop: '30px',
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '10px',
                                justifyContent: 'center',
                                width: '100%',
                                maxWidth: '100%'
                            }}>
                                {content.badges.map((badge, index) => {
                                    const gradients = [
                                        { bg: 'linear-gradient(135deg, rgba(102, 126, 234, 0.25) 0%, rgba(118, 75, 162, 0.25) 100%)', border: 'rgba(102, 126, 234, 0.5)', glow: 'rgba(102, 126, 234, 0.3)' },
                                        { bg: 'linear-gradient(135deg, rgba(16, 185, 129, 0.25) 0%, rgba(5, 150, 105, 0.25) 100%)', border: 'rgba(16, 185, 129, 0.5)', glow: 'rgba(16, 185, 129, 0.3)' },
                                        { bg: 'linear-gradient(135deg, rgba(245, 158, 11, 0.25) 0%, rgba(217, 119, 6, 0.25) 100%)', border: 'rgba(245, 158, 11, 0.5)', glow: 'rgba(245, 158, 11, 0.3)' },
                                        { bg: 'linear-gradient(135deg, rgba(239, 68, 68, 0.25) 0%, rgba(220, 38, 38, 0.25) 100%)', border: 'rgba(239, 68, 68, 0.5)', glow: 'rgba(239, 68, 68, 0.3)' },
                                        { bg: 'linear-gradient(135deg, rgba(139, 92, 246, 0.25) 0%, rgba(124, 58, 237, 0.25) 100%)', border: 'rgba(139, 92, 246, 0.5)', glow: 'rgba(139, 92, 246, 0.3)' },
                                        { bg: 'linear-gradient(135deg, rgba(6, 182, 212, 0.25) 0%, rgba(8, 145, 178, 0.25) 100%)', border: 'rgba(6, 182, 212, 0.5)', glow: 'rgba(6, 182, 212, 0.3)' },
                                        { bg: 'linear-gradient(135deg, rgba(236, 72, 153, 0.25) 0%, rgba(219, 39, 119, 0.25) 100%)', border: 'rgba(236, 72, 153, 0.5)', glow: 'rgba(236, 72, 153, 0.3)' },
                                        { bg: 'linear-gradient(135deg, rgba(251, 146, 60, 0.25) 0%, rgba(249, 115, 22, 0.25) 100%)', border: 'rgba(251, 146, 60, 0.5)', glow: 'rgba(251, 146, 60, 0.3)' }
                                    ];
                                    
                                    const currentGradient = gradients[index % gradients.length];
                                    
                                    return (
                                        <span 
                                            key={index}
                                            style={{
                                                background: currentGradient.bg,
                                                backdropFilter: 'blur(10px)',
                                                WebkitBackdropFilter: 'blur(10px)',
                                                border: `1px solid ${currentGradient.border}`,
                                                borderRadius: '10px',
                                                color: 'white',
                                                padding: '8px 16px',
                                                fontSize: '0.8rem',
                                                fontWeight: '600',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                textAlign: 'center',
                                                boxShadow: `0 4px 15px ${currentGradient.glow}`,
                                                transition: 'all 0.3s ease',
                                                cursor: 'default',
                                                whiteSpace: 'nowrap',
                                                fontFamily: '"Roboto", "Poppins", sans-serif',
                                                flex: '0 0 auto'
                                            }}
                                            data-aos="zoom-in" 
                                            data-aos-delay={400 + (index * 50)}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.transform = 'translateY(-3px) scale(1.05)';
                                                e.currentTarget.style.boxShadow = `0 8px 25px ${currentGradient.glow}`;
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = 'translateY(0) scale(1)';
                                                e.currentTarget.style.boxShadow = `0 4px 15px ${currentGradient.glow}`;
                                            }}
                                        >
                                            {badge}
                                        </span>
                                    );
                                })}
                            </div>

                            <div className="u-display-contents">
                                <div className="u-btn-group u-text-style-h2" style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', marginTop: '60px' }} data-aos="fade-up" data-aos-delay="800">
                                    {/* Modern Gradient CTA Button */}
                                    <a 
                                        href={`https://audiosum.app/signup?lang=${language}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-lg px-5 py-3"
                                        style={{ 
                                            fontSize: '1.1rem',
                                            borderRadius: '25px',
                                            background: 'rgba(255, 255, 255, 0.1)',
                                            backdropFilter: 'blur(10px)',
                                            WebkitBackdropFilter: 'blur(10px)',
                                            border: '2px solid rgba(255, 255, 255, 0.2)',
                                            boxShadow: '0 8px 30px rgba(255, 255, 255, 0.1)',
                                            color: 'white',
                                            fontWeight: '600',
                                            textDecoration: 'none',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            transition: 'all 0.3s ease'
                                        }}
                                        onMouseOver={(e) => {
                                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)';
                                            e.currentTarget.style.transform = 'translateY(-2px)';
                                            e.currentTarget.style.boxShadow = '0 12px 40px rgba(255, 255, 255, 0.2)';
                                        }}
                                        onMouseOut={(e) => {
                                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.boxShadow = '0 8px 30px rgba(255, 255, 255, 0.1)';
                                        }}
                                    >
                                        {content.ctaButton}
                                    </a>
                                    
                                    {/* Demo Video Button - Temporarily Hidden */}
                                    {/* <Link 
                                        to={`/${language}/watch-demo`}
                                        className="btn btn-lg px-5 py-3"
                                        style={{ 
                                            fontSize: '1.1rem',
                                            borderRadius: '50px',
                                            background: 'rgba(255, 255, 255, 0.1)',
                                            border: '2px solid rgba(255, 255, 255, 0.3)',
                                            color: 'white',
                                            fontWeight: '600',
                                            textDecoration: 'none',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            backdropFilter: 'blur(10px)',
                                            transition: 'all 0.3s ease'
                                        }}
                                        onMouseOver={(e) => {
                                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)';
                                            e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.5)';
                                        }}
                                        onMouseOut={(e) => {
                                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                                            e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                                        }}
                                    >
                                        <i className="fas fa-play-circle me-2"></i>
                                        {content.demoButton}
                                    </Link> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div data-wf--global-section-space--section-space="main" className="g_section_space w-variant-60a7ad7d-02b0-6682-95a5-2218e6fd1490"></div>

                </header>
            </main>
        </div>
    )
}

export default HeroSection
